import { h } from "preact";

export default function List({ children, ...props }) {
  return (
    <div class="list" {...props}>
      {children}
    </div>
  );
}
